import { DataNode } from 'antd/es/tree';
import { Dayjs } from 'dayjs';

export interface NewDataNode extends DataNode {
  key: number;
  rawTitle: string;
  energyUnitId?: number;
  children?: NewDataNode[];
}

// 时间颗粒度
export enum DateType {
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
}

export const DateTypeDisplay = {
  [DateType.DAY]: '按日',
  [DateType.WEEK]: '按周',
  [DateType.MONTH]: '按月',
  [DateType.YEAR]: '按年',
};

export const DateTypeForMat = {
  [DateType.DAY]: 'YYYY-MM-DD',
  [DateType.WEEK]: 'YYYY-MM-DD',
  [DateType.MONTH]: 'YYYY-MM',
  [DateType.YEAR]: 'YYYY',
};

/**
 * 获取默认时间
 */

export type RangeValue = [Dayjs | null, Dayjs | null] | null;

export const getDefaultTime = (mode: DateType, date: RangeValue) => {
  let startTime = date?.[0]?.startOf('day').valueOf();
  let endTime = date?.[1]?.endOf('day').valueOf();

  switch (mode) {
    case DateType.WEEK:
      startTime = date?.[0]?.startOf('week').startOf('day').valueOf();
      endTime = date?.[1]?.endOf('week').endOf('day').valueOf();

      break;
    case DateType.MONTH:
      startTime = date?.[0]?.startOf('month').startOf('day').valueOf();
      endTime = date?.[1]?.endOf('month').endOf('day').valueOf();
      break;
    case DateType.YEAR:
      startTime = date?.[0]?.startOf('year').startOf('day').valueOf();
      endTime = date?.[1]?.endOf('year').endOf('day').valueOf();
      break;
  }
  return {
    startTime,
    endTime,
  };
};

// 获取整棵树所有 key
export const getAllKeys = (tree: any[], keys: number[] = []) => {
  tree.forEach(node => {
    keys.push(node.key as number);
    if (node.children?.length) {
      getAllKeys(node.children, keys);
    }
  });
  return keys;
};

// 获取某个节点的所有子孙 key
export const getChildrenKeys = (node?: any, keys: number[] = []) => {
  if (!node?.children) return keys;

  node.children.forEach((child: any) => {
    keys.push(child.key);
    getChildrenKeys(child, keys);
  });

  return keys;
};
